import type { Tournament } from "@/entities/tournament/model/types";

/**
 * Архивная запись турнира → объект для карточки/строки списка.
 *
 * Архив и живой турнир описывают одно и то же разными полями, и карточка читает
 * живые. До этой функции маппинг заполнял только currentTeams/maxTeams, поэтому
 * список архива показывал «Участники 0», «Команд —» и «Призовые 0 ₽» при том,
 * что в самом архиве лежали 42 игрока, 8 команд и 5000 ₽.
 *
 * Отдельная функция (а не инлайн в странице) — чтобы это соответствие можно было
 * проверить тестом: полей много, и молчаливо потерять любое из них легко.
 */
export function archiveToTournament(a: Record<string, unknown>): Tournament {
  // У драфта это РАЗНЫЕ числа: totalParticipants — команды, totalPlayers — люди.
  const totalTeams = Number(a["totalParticipants"] ?? 0);
  const totalPlayers = a["totalPlayers"] == null ? null : Number(a["totalPlayers"]);
  const type = (a["type"] as string) ?? undefined;
  const winnerName =
    ((a["winner"] as Record<string, unknown> | null)?.["winnerName"] as string | null) ?? null;

  return {
    id: String((a["tournamentId"] as string) ?? (a["id"] as string) ?? ""),
    name: String(a["name"] ?? ""),
    image: (a["image"] as string | null) ?? undefined,
    startDate: (a["startDate"] as string | null) ?? null,
    endDate: a["endDate"] as string | null,
    format: (a["format"] as string) ?? undefined,
    type,
    currentTeams: totalTeams,
    maxTeams: totalTeams,
    // Драфт: «Участники» — люди, «Команд» — сколько их собрали.
    registeredPlayersCount: totalPlayers ?? totalTeams,
    ...(type === "Draft" ? { maxTeamsInDraft: totalTeams } : {}),
    prizePool: a["prizePool"] == null ? null : Number(a["prizePool"]),
    ...(winnerName ? { winner: { name: winnerName } } : {}),
    status: "Completed" as const,
    backendStatus: "Completed",
  } as Tournament;
}
